import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './index.css'
import Header from './components/Header'
import MobHeader from './components/MobHeader.js'
import Home from './components/Home'
import AboutUs from './components/AboutUs'
import Footer from './components/Footer.js'
import AbracaKeralty from './components/AbracaKeralty.js'
import Transparency from './components/Transparency.js'
import Corrente from './components/volunteer/corrente-do-bem.js'
import Palhacaria from './components/volunteer/palhacaria.js'
import Musicos from './components/volunteer/musicos.js'
import CriancasAtipicas from './components/volunteer/criancas-atipicas.js'
import CuidadosPaliativos from './components/volunteer/cuidados.js'
import CasaDeRepouso from './components/volunteer/casa-repouso.js'
export default function App () {
  return (
    <Router>
      <Header />
      <MobHeader />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<AboutUs />} />
        <Route path='/abraca-keralty' element={<AbracaKeralty />} />
        <Route path='/transparency' element={<Transparency />}/>
        <Route path='/volunteer/corrente-do-bem' element={<Corrente />}/>
        <Route path='/volunteer/musicos' element={<Musicos />}/>
        <Route path='/volunteer/palhacaria' element={<Palhacaria />}/>
        <Route path='/volunteer/criancas-atipicas' element={<CriancasAtipicas />}/>
        <Route path='/volunteer/cuidados-paliativos' element={<CuidadosPaliativos />}/>
        <Route path='/volunteer/casa-de-repouso' element={<CasaDeRepouso />}/>

      </Routes>
      <Footer />
    </Router>
  )
}
